module.exports = __webpack_public_path__ + "static/media/scott-hanselman_200x200.786aa90d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/scott-hanselman_200x200.png
// module id = 323
// module chunks = 0